import {createAsyncThunk} from '@reduxjs/toolkit';

import omit from '@tinkoff/utils/object/omit';

import type {AxiosError} from 'axios';

import type {AppDispatch} from 'stores/redux_store';
import {Client4} from 'mattermost-redux/client';
import {forceLogoutIfNecessaryThunkAxios} from 'mattermost-redux/actions/helpers';
import type {User} from 'features/users';
import type {Team} from '@mattermost/types/teams';
import type {ServerThread} from '../types/threads';
import {type StatusOK} from '@mattermost/types/client4';

type Payload = {

    /**
     * The ID of the user. This can also be "me" which will point to the current user.
     */
    userId: User['id'] | 'me';

    /**
     * The ID of the team in which the thread is.
     */
    teamId: Team['id'];

    /**
     * The ID of the thread to follow
     */
    threadId: ServerThread['id'];
};

/**
 * Stop following a thread
 *
 * Stop following a thread
 *
 * Must be logged in as the user or have `edit_other_users` permission.
 *
 * @see https://messenger.pages.devplatform.tcsbank.ru/time-api-reference/#operation/StopFollowingThread
 * @example "/users/{user_id}/teams/{team_id}/threads/{thread_id}/following"
 */
export const stopFollowingThread = createAsyncThunk(
    'threads/api/stopFollowingThread',
    async (payload: Payload, thunkAPI) => {
        const {teamId, userId, threadId} = payload;
        const dispatch = thunkAPI.dispatch as AppDispatch;

        const requester = Client4.requester;

        const options = omit(['url'], Client4.getTimeApiClientOptions({}));

        const url = `${Client4.getUrl()}/api/v4/users/${userId}/teams/${teamId}/threads/${threadId}/following`;

        try {
            const {data} = await requester.delete<StatusOK>(url, {
                ...options,
            });

            return data;
        } catch (e) {
            const error = e as AxiosError;

            dispatch(forceLogoutIfNecessaryThunkAxios(error));

            throw error;
        }
    },
);
